module.exports = __webpack_public_path__ + "static/img/Ingenio Vital.84d0d59d.png";